// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_B4Q","cls2":"ReferenceEvaluationPage-cls2_uoN ReferenceEvaluationPage-cls1_B4Q","fadeInUp":"ReferenceEvaluationPage-fadeInUp_AaH"};